// extracted by mini-css-extract-plugin
export default {"sms-code-content":"sms-code-content___SOycD"};